// Форматирование дат и обратного отсчёта на языке интерфейса.
// Единый источник для всех экранов: подписи «д/ч/м/с» берутся из локали, даты — из dateLocale().
import { dateLocale, t } from './index';

// Остаток времени в компактном виде: 2д 5ч / 5ч 12м / 12м 30с / 30с.
export function fmtRemaining(sec, opts) {
  const full = opts && opts.full;   // full=true → «2д 5ч 12м» (шапка), иначе две старшие единицы
  if (sec <= 0) return `0${t('time.s')}`;
  const d = Math.floor(sec / 86400);
  const h = Math.floor((sec % 86400) / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  if (d > 0) return full ? `${d}${t('time.d')} ${h}${t('time.h')} ${m}${t('time.m')}` : `${d}${t('time.d')} ${h}${t('time.h')}`;
  if (h > 0) return full ? `${h}${t('time.h')} ${m}${t('time.m')} ${s}${t('time.s')}` : `${h}${t('time.h')} ${m}${t('time.m')}`;
  if (m > 0) return `${m}${t('time.m')} ${s}${t('time.s')}`;
  return `${s}${t('time.s')}`;
}

// Дата+время (unix-секунды) в коротком локальном формате.
export function fmtDateTime(unix) {
  if (!unix) return '—';
  return new Date(unix * 1000).toLocaleString(dateLocale(), { dateStyle: 'short', timeStyle: 'short' });
}

// Только день и месяц («28.07» / «28 Jul»).
export function fmtDay(unix) {
  if (!unix) return '—';
  return new Date(unix * 1000).toLocaleDateString(dateLocale(), { day: '2-digit', month: '2-digit' });
}
